var exports = {
  "HS": "ChannelMembers.module__groupContainer___SDVjbV",
  "x_": "ChannelMembers.module__groupHeader___SDVjbV",
  "nF": "ChannelMembers.module__virtualGroupRow___SDVjbV",
  "xQ": "ChannelMembers.module__groupHeaderLabel___SDVjbV",
  "A5": "ChannelMembers.module__groupHeaderRoleIcon___SDVjbV",
  "Px": "ChannelMembers.module__groupHeaderSeparator___SDVjbV",
  "gV": "ChannelMembers.module__groupHeaderCount___SDVjbV",
  "cr": "ChannelMembers.module__membersList___SDVjbV",
  "fL": "ChannelMembers.module__virtualListContent___SDVjbV",
  "wt": "ChannelMembers.module__virtualRow___SDVjbV",
  "ar": "ChannelMembers.module__virtualMemberRow___SDVjbV",
  "CU": "ChannelMembers.module__groupSpacer___SDVjbV",
};

module.exports = exports;
